import type { WellControlAreaValue } from 'types/type-curve-workspace-show';
import type { MapBounds, TcMapFilterMode } from '../types';

// Persisted Well Control Area kind (backend snake_case) — the counterpart of the
// hyphenated FE `TcMapFilterMode`.
export type WellControlAreaKind =
  'type_curve_area' | 'map_extent' | 'aoi_polygon';

// FE Global Map Filter mode ⇄ persisted Well Control Area kind.
export const WCA_KIND_BY_MODE: Record<TcMapFilterMode, WellControlAreaKind> = {
  'type-curve-area': 'type_curve_area',
  'visible-extent': 'map_extent',
  'aoi-polygon': 'aoi_polygon',
};

export const MODE_BY_WCA_KIND: Record<WellControlAreaKind, TcMapFilterMode> = {
  type_curve_area: 'type-curve-area',
  map_extent: 'visible-extent',
  aoi_polygon: 'aoi-polygon',
};

// Build the `header.value` for the `well_control_area` task save from the current
// Global Map Filter selection. Mirrors the spatial translation in
// build-tc-wells-query-payload.ts. Returns null when the selected mode has no
// spatial data yet (extent with no bounds / polygon not drawn) so the caller can
// omit the header rather than trigger a backend 422 on an empty geometry.
export function buildWellControlAreaValue(
  mode: TcMapFilterMode,
  bounds: MapBounds | null,
  polygon: GeoJSON.Polygon | null
): WellControlAreaValue | null {
  switch (mode) {
    case 'type-curve-area':
      return { kind: 'type_curve_area' };
    case 'visible-extent':
      return bounds
        ? {
            kind: 'map_extent',
            bbox: [bounds.sw_lng, bounds.sw_lat, bounds.ne_lng, bounds.ne_lat],
          }
        : null;
    case 'aoi-polygon':
      return polygon
        ? { kind: 'aoi_polygon', polygon_geo_json: polygon }
        : null;
    default:
      return null;
  }
}
